import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { transientOptions } from "@product/scmp-sdk";

import ImageWaveBg from "./img-wave-background.svg";

const waveBackgroundStyle = css`
  inline-size: 100%;
  block-size: auto;
`;

type WaveBackgroundProps = {
  $fillColor: string;
};

export const WaveUpperBackground = styled(ImageWaveBg, {
  ...transientOptions,
})<WaveBackgroundProps>(
  props => css`
    margin-block-end: -5px;
    ${waveBackgroundStyle}

    ${props.$fillColor &&
    css`
      fill: ${props.$fillColor};
    `}
  `,
);

export const WaveBottomBackground = styled(ImageWaveBg, {
  ...transientOptions,
})<WaveBackgroundProps>(
  props => css`
    margin-block-start: -5px;
    ${waveBackgroundStyle}
    transform: rotate(180deg);
    ${props.$fillColor &&
    css`
      fill: ${props.$fillColor};
    `}
  `,
);
